<template>
	<div>
		<div class="tab-box">
			<el-table
				v-loading="loading"
				element-loading-text="加载中"
				:header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
			>
				<el-table-column label="序号" width="100">
					<template slot-scope="scope">
						{{ scope.$index + 1 }}
					</template>
				</el-table-column>
				
				<el-table-column prop="name" label="审批名称"> </el-table-column>
				<el-table-column label="审批人员">
					<template slot-scope="scope">
						<span v-for="(v,k) in scope.row.approvers" :key="k" class="btn-txt txtC">{{v.label}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="350" align="center">
					<template slot-scope="scope">
						<span class="btn-txt txtC" @click="handleEdit(scope.row)">修改</span>
						<!-- <span class="btn-txt del-txt" @click="handleDel(scope.row)">删除</span> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="page-box">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 15, 20, 30, 50, 100]"
					:page-size="10"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
		<el-dialog :destroy-on-close="true" :visible.sync="dialogVisible" width="50%">
		  <div slot="title" class="title">修改审批人员</div>
		  <div>
		  <!--  <el-form
		      size="small"
		      ref="ruleForm"
		      label-width="100px"
		      class="demo-ruleForm"
		      label-position="top"
		    > -->
		     <el-transfer 
				v-model="value"
				:titles="['人员列表','审批人员']"
				target-order="push"
			    @change="handleChange"
			    :data="treeArr"
				></el-transfer>
		    <!-- </el-form> -->
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button class="small-btn btn-bor" size="small" @click="close"
		      >取 消</el-button
		    >
		    <el-button
		      class="small-btn bgC"
		      size="small"
		      type="primary"
		      @click="submitForm()"
		      >修 改</el-button
		    >
		  </span>
		</el-dialog>
	</div>
</template>

<script scoped>
import addAccount from '../../components/dialog/addAccount.vue';
export default {
	components: {
		addAccount
	},
	data() {
		return {
			dialogVisible:false,
			disabled:false,
			title:'新建账号',
			accountObj:'',//修改对象
			roleArr:[],//角色列表
			tableData: [],
			pageObj: {
				limit: 10,
				page: 1
			},
			total: 0, //总条数
			multipleSelection: [], //勾选的数据
			currentPage: 1, //当前页
			loading: true ,//是否显示加载中图标
			treeArr:[],
			value:[],
			rightArr:[],
			type:'',
			name:''
		};
	},
	created() {
		this.usrList();
		this.getList();
	},
	methods: {
		usrList(){
			this.$api.usrList().then((res)=>{
				if(res.code == 1){
					let data = res.data
					data.forEach((v,k)=>{
						this.treeArr.push({label:v.name,key:v.id})
					})
					this.treeArr.unshift({label:'提审人的组长',key:'captain'})
					// this.rightArr = [2]
				}
			})
		},
		// 右侧值
		handleChange(value, direction, movedKeys){
			 console.log(value);
		},
		// 确认修改
		submitForm(){
			let obj = {
				type:this.type,
				name:this.name,
				approvers:this.value.toString()
			}
			console.log(obj);
			this.$api2.approvalEdit(obj).then((res)=>{
				if(res.code == 1){
					this.getList()
					this.dialogVisible = false;
					this.$message.success(res.msg)
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// 修改弹框
		handleEdit(v){
			let arr = v.approvers;
			this.type = v.type
			this.name = v.name
			this.value = []
			arr.forEach((item,index)=>{
				if(item.key){
					this.value.push(item.key)
				}
			})
			this.dialogVisible = true;
		},
		
		//   关闭弹框
		close() {
		  this.dialogVisible = false;
		  this.$refs["ruleForm"].resetFields();
		},
		// 获取数据列表
		getList() {
			this.loading = true;
			this.$api2.approvalConfig(this.pageObj).then(res => {
				this.loading = false;
				if (res.code == 1) {
					this.total = res.count;
					this.tableData = res.data;
				}
			})
			.catch(err => {
				this.loading = false;
			});
		},
		// 多选事件
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(val);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pageObj.limit = val;
			this.getList();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pageObj.page = val;
			this.getList();
		}
	}
};
</script>

<style lang="scss">
@import '../../assets/css/public.scss';
</style>
